/* eslint-disable no-debugger */
/* eslint-disable camelcase */

import { useHistory } from 'react-router';

import { useMeLazyQuery } from '@school_ify/schoolify-repository/src/shared/types';
import {
  clearAuthLocalStorage,
  resetApolloStore,
} from '@school_ify/schoolify-repository/src/client';
import { useLoginMutation } from '@school_ify/schoolify-repository/src/public/types';

import { LoginCredentials } from 'types/authentication/index';
import { useAppSelector, useAppDispatch } from 'redux/hooks';
import {
  setUser,
  getUser,
  setError,
  getLoading,
  getError,
  getProfilePicture,
} from 'redux/authentication/auth.slice';
import { cleanActiveChat } from 'redux/chat/actions';

export default function useAuthentication() {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const user = useAppSelector(getUser);
  const isLoading = useAppSelector(getLoading);
  const authError = useAppSelector(getError);

  const [me] = useMeLazyQuery();
  const [loginEmailPassword] = useLoginMutation();

  const getCurrentUser = async () => {
    try {
      // eslint-disable-next-line no-debugger
      const token = localStorage.getItem('token');
      const refresh_token = localStorage.getItem('refresh_token');

      if (!token && !refresh_token) {
        throw new Error('Can not get token from cookies');
      }
      const { data } = await me();
      dispatch(setUser(data.me));
      dispatch(getProfilePicture(data.me.id));
    } catch (error) {
      clearAuthLocalStorage();
      dispatch(setError(error.message.toString()));
    }
  };

  const login = async (credentials: LoginCredentials) => {
    try {
      const { data } = await loginEmailPassword({ variables: credentials });
      const { jwt_token, refresh_token, directus_token } = data.login_email_password;

      localStorage.setItem('token', jwt_token);
      localStorage.setItem('refresh_token', refresh_token);
      // @ts-ignore
      if (directus_token) {
        // @ts-ignore
        localStorage.setItem('directus_login', directus_token);
      }
      await getCurrentUser();
    } catch (error) {
      dispatch(setError(error.message.toString()));
    }
  };

  const logOut = async () => {
    try {
      // Clear redux state
      dispatch(setUser(null));
      dispatch(cleanActiveChat());
      // Cleare local storage
      clearAuthLocalStorage();
      // Clear apollo store
      resetApolloStore();
      // Redirect to login
      history.push('/');
    } catch (error) {
      dispatch(setError(error.message.toString()));
    }
  };

  return {
    user,
    login,
    logOut,
    isLoading,
    error: authError,
    getCurrentUser,
  };
}
